import React, { useEffect } from 'react';
import { modalIds } from '../../constants';
import { useSelectedParam } from '../../model/modalParam';
import ChangeStage from './components/ChangeStage/ChangeStage';
import ChangeStep from './components/ChangeStep/ChangeStep';
import ChangeSale from './components/ChangeSale/ChangeSale';
import useValidateFlatsStage from '../../hooks/useValidateFlatsStage';
import { useDispatch } from 'react-redux';
import { setSelectedFlats } from '../../../../../store/actions/housingStockActions';
import { message } from 'antd';
import BaseModal from '../BaseModal/BaseModal';
import { useModalVisible } from '../../model/modelState';

const lifeCycleParams = [modalIds.stage, modalIds.step];

const ModalFactory = ({ flats }) => {
  const param = useSelectedParam();

  const visibleModal = useModalVisible();

  const commonProps = { flats };

  const validateMessage = useValidateFlatsStage({
    flats,
    entity: lifeCycleParams.includes(param?.id) && 'lifeCycle',
  });

  const dispatch = useDispatch();

  useEffect(() => {
    if (validateMessage && visibleModal) {
      message.info(validateMessage);
      dispatch(setSelectedFlats([]));
    }
  }, [dispatch, validateMessage, visibleModal]);

  switch (param?.id) {
    case modalIds.stage:
      return <ChangeStage {...commonProps} />;

    case modalIds.step:
      return <ChangeStep {...commonProps} />;

    case modalIds.sale:
      return <ChangeSale {...commonProps} />;

    default:
      return <BaseModal>Нет Данных</BaseModal>;
  }
};

export default ModalFactory;
